/* eslint-disable max-len */
import React from "react";

export interface IIcon {
  width?: number;
  height?: number;
  color?: string;
  secondaryColor?: string;
  style?: React.CSSProperties;
  strokeWidth?: number;
  size?: number;
}

export const EstateLogsLogo = ({
  width = 25,
  height = 25,
  style,
  size
}: IIcon) => (
  <svg
    height={size || height}
    width={size || width}
    style={style}
    viewBox="0 0 36 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 13.9229C0 12.1454 0.885531 10.4847 2.3615 9.49426L15.0282 0.994258C16.8258 -0.212031 19.1742 -0.212032 20.9718 0.994257L33.6385 9.49426C35.1145 10.4847 36 12.1454 36 13.9229V24.9298C36 27.8753 33.6122 30.2632 30.6667 30.2632H5.33333C2.38782 30.2632 0 27.8753 0 24.9298V13.9229Z"
      fill="#3139EB"
    />

    <path
      d="M4.26318 14.533C4.26318 13.5696 4.78281 12.6811 5.62249 12.2088L7.09266 11.3818C7.67064 11.0567 8.38937 11.1224 8.89882 11.5469C9.26309 11.8505 9.47371 12.3002 9.47371 12.7743V23.1576C9.47371 24.5964 8.30729 25.7628 6.86845 25.7628C5.4296 25.7628 4.26318 24.5964 4.26318 23.1576V14.533Z"
      fill="#F6F6F9"
    />

    <path
      d="M12.3159 9.85611C12.3159 9.02739 12.7012 8.24576 13.3585 7.74104L14.8885 6.5662C15.5733 6.04044 16.5484 6.13574 17.1183 6.78411V6.78411C17.3814 7.08334 17.5264 7.46812 17.5264 7.86653V23.395C17.5264 24.8338 16.36 26.0003 14.9212 26.0003V26.0003C13.4823 26.0003 12.3159 24.8338 12.3159 23.395V9.85611Z"
      fill="#F6F6F9"
    />
  </svg>
);

export const EyeCrossed = ({
  width = 25,
  height = 25,
  color = `currentColor`,
  style,
  size
}: IIcon) => (
  <svg
    height={size || height}
    width={size || width}
    style={style}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill={color}
      d="M1.45519 3.18946C1.06519 2.88517 0.498952 2.95568 0.191457 3.34161C-0.116037 3.72754 -0.0447884 4.28788 0.345205 4.59217L22.5448 21.8105C22.9348 22.1148 23.501 22.0443 23.8085 21.6584C24.116 21.2725 24.0448 20.7121 23.6548 20.4078L19.7099 17.3501C21.1948 15.8435 22.1998 14.155 22.7061 12.9564C22.8298 12.6633 22.8298 12.3367 22.7061 12.0436C22.1473 10.7188 20.9736 8.78914 19.2186 7.17863C17.4562 5.55328 15.0299 4.18768 12 4.18768C9.44255 4.18768 7.31258 5.16364 5.65136 6.44388L1.45519 3.18946ZM8.36631 8.54794C9.32255 7.68331 10.6013 7.15637 12 7.15637C14.9812 7.15637 17.3999 9.54987 17.3999 12.5C17.3999 13.424 17.1637 14.2923 16.7474 15.0494L15.2999 13.9287C15.4949 13.4908 15.5999 13.0084 15.5999 12.5C15.5999 10.5332 13.9875 8.93758 12 8.93758C11.895 8.93758 11.79 8.94129 11.685 8.95242C11.8838 9.29753 12 9.6983 12 10.1251C12 10.5036 11.91 10.8598 11.7525 11.1752L8.36631 8.54794V8.54794ZM16.7324 19.6063L13.9875 17.4688C13.3725 17.71 12.7012 17.8436 12 17.8436C9.0188 17.8436 6.60009 15.4501 6.60009 12.5C6.60009 12.244 6.61884 11.9953 6.65259 11.7504L3.11641 8.99324C2.26142 10.0954 1.65018 11.1938 1.29394 12.0436C1.17019 12.3367 1.17019 12.6633 1.29394 12.9564C1.85268 14.2812 3.02641 16.2109 4.78138 17.8214C6.54385 19.4467 8.97005 20.8123 12 20.8123C13.7925 20.8123 15.3712 20.3336 16.7324 19.6063Z"
    />
  </svg>
);

export const Eye = ({
  width = 25,
  height = 25,
  color = `currentColor`,
  style,
  size
}: IIcon) => (
  <svg
    height={size || height}
    width={size || width}
    style={style}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill={color}
      d="M11.9981 4C8.91225 4 6.44128 5.39643 4.64248 7.05848C2.85513 8.70536 1.65975 10.6786 1.09452 12.0333C0.968492 12.333 0.968492 12.667 1.09452 12.9667C1.65975 14.3214 2.85513 16.2946 4.64248 17.9415C6.44128 19.6036 8.91225 21 11.9981 21C15.0839 21 17.5549 19.6036 19.3537 17.9415C21.141 16.2908 22.3364 14.3214 22.9055 12.9667C23.0315 12.667 23.0315 12.333 22.9055 12.0333C22.3364 10.6786 21.141 8.70536 19.3537 7.05848C17.5549 5.39643 15.0839 4 11.9981 4ZM17.4976 12.5C17.4976 15.5167 15.0343 17.9643 11.9981 17.9643C8.9619 17.9643 6.49857 15.5167 6.49857 12.5C6.49857 9.48326 8.9619 7.03571 11.9981 7.03571C15.0343 7.03571 17.4976 9.48326 17.4976 12.5ZM11.9981 10.0714C11.9981 11.4109 10.902 12.5 9.55386 12.5C9.11466 12.5 8.7022 12.3862 8.34702 12.1813C8.33938 12.2875 8.33174 12.39 8.33174 12.5C8.33174 14.5112 9.97396 16.1429 11.9981 16.1429C14.0222 16.1429 15.6644 14.5112 15.6644 12.5C15.6644 10.4888 14.0222 8.85714 11.9981 8.85714C11.8912 8.85714 11.7842 8.86094 11.6773 8.87232C11.8797 9.22522 11.9981 9.63504 11.9981 10.0714Z"
    />
  </svg>
);

export const ExclamationSign = ({
  width = 25,
  height = 25,
  color = `currentColor`,
  style,
  size
}: IIcon) => (
  <svg
    height={size || height}
    width={size || width}
    style={style}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_11104_2204)">
      <path
        d="M8 16C12.4187 16 16 12.4187 16 8C16 3.58125 12.4187 0 8 0C3.58125 0 0 3.58125 0 8C0 12.4187 3.58125 16 8 16ZM8 4C8.41563 4 8.75 4.33437 8.75 4.75V8.25C8.75 8.66563 8.41563 9 8 9C7.58437 9 7.25 8.66563 7.25 8.25V4.75C7.25 4.33437 7.58437 4 8 4ZM9 11C9 11.5531 8.55313 12 8 12C7.44687 12 7 11.5531 7 11C7 10.4469 7.44687 10 8 10C8.55313 10 9 10.4469 9 11Z"
        fill={color}
      />
    </g>

    <defs>
      <clipPath id="clip0_11104_2204">
        <rect width="16" height="16" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

export const InfoSign = ({
  width = 25,
  height = 25,
  color = `currentColor`,
  style,
  size
}: IIcon) => (
  <svg
    height={size || height}
    width={size || width}
    style={style}
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="8.15381" cy="8.99219" r="8" fill={color} />

    <path
      d="M9.29144 7.7087L7.27692 7.96118L7.20479 8.29546L7.60065 8.36848C7.85929 8.43006 7.91031 8.52331 7.85401 8.78106L7.20479 11.8319C7.03413 12.621 7.29716 12.9922 7.91559 12.9922C8.39502 12.9922 8.95188 12.7705 9.20435 12.4661L9.28176 12.1002C9.10582 12.255 8.84895 12.3166 8.67829 12.3166C8.43637 12.3166 8.3484 12.1468 8.41086 11.8477L9.29144 7.7087ZM9.35302 5.87189C9.35302 6.1052 9.26034 6.32895 9.09536 6.49393C8.93038 6.65891 8.70663 6.75159 8.47332 6.75159C8.24001 6.75159 8.01625 6.65891 7.85128 6.49393C7.6863 6.32895 7.59362 6.1052 7.59362 5.87189C7.59362 5.63858 7.6863 5.41482 7.85128 5.24985C8.01625 5.08487 8.24001 4.99219 8.47332 4.99219C8.70663 4.99219 8.93038 5.08487 9.09536 5.24985C9.26034 5.41482 9.35302 5.63858 9.35302 5.87189Z"
      fill="#F6F6F9"
    />
  </svg>
);

export const CheckSign = ({
  width = 25,
  height = 25,
  color = `currentColor`,
  style,
  size
}: IIcon) => (
  <svg
    height={size || height}
    width={size || width}
    style={style}
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="8.32715" cy="8.99219" r="8" fill={color} />

    <path
      d="M5.35693 9.6875L7.67404 11.8317"
      stroke="#F6F6F9"
      strokeWidth="1.2469"
      strokeLinecap="round"
    />

    <path
      d="M11.8916 6.15234L7.67419 11.8324"
      stroke="#F6F6F9"
      strokeWidth="1.2469"
      strokeLinecap="round"
    />
  </svg>
);

export const Profile = ({
  width = 25,
  height = 25,
  color = `currentColor`,
  style,
  size
}: IIcon) => (
  <svg
    height={size || height}
    width={size || width}
    style={style}
    viewBox="0 0 59 59"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M40.5625 22.125C40.5625 25.059 39.397 27.8727 37.3224 29.9474C35.2477 32.022 32.434 33.1875 29.5 33.1875C26.566 33.1875 23.7523 32.022 21.6776 29.9474C19.603 27.8727 18.4375 25.059 18.4375 22.125C18.4375 19.191 19.603 16.3773 21.6776 14.3026C23.7523 12.228 26.566 11.0625 29.5 11.0625C32.434 11.0625 35.2477 12.228 37.3224 14.3026C39.397 16.3773 40.5625 19.191 40.5625 22.125Z"
      fill={color}
    />

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 29.5C0 21.6761 3.10803 14.1727 8.64035 8.64035C14.1727 3.10803 21.6761 0 29.5 0C37.3239 0 44.8273 3.10803 50.3596 8.64035C55.892 14.1727 59 21.6761 59 29.5C59 37.3239 55.892 44.8273 50.3596 50.3596C44.8273 55.892 37.3239 59 29.5 59C21.6761 59 14.1727 55.892 8.64035 50.3596C3.10803 44.8273 0 37.3239 0 29.5ZM29.5 3.6875C24.6391 3.68776 19.877 5.06059 15.7619 7.64798C11.6467 10.2354 8.34585 13.9322 6.23912 18.3128C4.13238 22.6935 3.30542 27.5801 3.85343 32.41C4.40144 37.24 6.30213 41.817 9.33675 45.6144C11.9549 41.3959 17.7184 36.875 29.5 36.875C41.2816 36.875 47.0414 41.3922 49.6632 45.6144C52.6979 41.817 54.5986 37.24 55.1466 32.41C55.6946 27.5801 54.8676 22.6935 52.7609 18.3128C50.6541 13.9322 47.3533 10.2354 43.2381 7.64798C39.123 5.06059 34.3609 3.68776 29.5 3.6875Z"
      fill={color}
    />
  </svg>
);

export const Cross = ({
  width = 25,
  height = 25,
  color = `currentColor`,
  style,
  size
}: IIcon) => (
  <svg
    height={size || height}
    width={size || width}
    style={style}
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.247899 0.243962C0.170314 0.321362 0.108758 0.413311 0.0667584 0.514542C0.0247585 0.615772 0.00314016 0.724296 0.00314016 0.833896C0.00314016 0.943496 0.0247585 1.05202 0.0667584 1.15325C0.108758 1.25448 0.170314 1.34643 0.247899 1.42383L3.82197 5.0001L0.244567 8.57636C0.0881298 8.7326 0.000156448 8.94459 2.08181e-07 9.16571C-7.71539e-05 9.27519 0.0214076 9.38362 0.0632275 9.4848C0.105047 9.58597 0.166383 9.67793 0.243733 9.7554C0.321084 9.83287 0.412934 9.89434 0.514039 9.93631C0.615144 9.97828 0.723524 9.99992 0.832992 10C1.05407 10.0002 1.26616 9.91247 1.42259 9.75623L5 6.1783L8.57574 9.75623C8.73217 9.91247 8.94426 10.0002 9.16534 10C9.38642 9.99984 9.59838 9.91186 9.7546 9.7554C9.91081 9.59894 9.99849 9.38682 9.99833 9.16571C9.99818 8.94459 9.9102 8.7326 9.75377 8.57636L6.17969 5.0001L9.75543 1.42383C9.91187 1.26759 9.99984 1.0556 10 0.834484C10.0002 0.613373 9.91248 0.401255 9.75626 0.244795C9.60005 0.0883349 9.38809 0.000348566 9.16701 0.000192303C8.94593 3.604e-05 8.73384 0.0877223 8.5774 0.243962L5.00167 3.82189L1.42426 0.243962C1.26803 0.0877531 1.05616 0 0.835247 0C0.614334 0 0.402466 0.0877531 0.246233 0.243962H0.247899Z"
      fill={color}
    />
  </svg>
);

export const ChevronLeft = ({
  width = 6,
  height = 12,
  color = `currentColor`,
  style,
  size
}: IIcon) => (
  <svg
    height={size || height}
    width={size || width}
    style={style}
    viewBox="0 0 8 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7 1L1.70711 6.29289C1.31658 6.68342 1.31658 7.31658 1.70711 7.70711L7 13"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const Spinner = ({
  width = 44,
  height = 44,
  size,
  color = `currentColor`,
  style = {}
}: IIcon) => (
  <svg
    height={size || height}
    width={size || width}
    style={style}
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path d="M11.25 1V4C11.25 4.19891 11.171 4.38968 11.0303 4.53033C10.8897 4.67098 10.6989 4.75 10.5 4.75C10.3011 4.75 10.1103 4.67098 9.96967 4.53033C9.82902 4.38968 9.75 4.19891 9.75 4V1C9.75 0.801088 9.82902 0.610322 9.96967 0.46967C10.1103 0.329018 10.3011 0.25 10.5 0.25C10.6989 0.25 10.8897 0.329018 11.0303 0.46967C11.171 0.610322 11.25 0.801088 11.25 1ZM14.7469 6.50312C14.8443 6.50399 14.941 6.48535 15.0311 6.44832C15.1213 6.41129 15.2032 6.35662 15.2719 6.2875L17.3906 4.16875C17.4659 4.10053 17.5266 4.01773 17.5689 3.92536C17.6112 3.83299 17.6343 3.73299 17.6368 3.63142C17.6393 3.52986 17.6211 3.42884 17.5834 3.3345C17.5457 3.24016 17.4892 3.15447 17.4174 3.08263C17.3455 3.01079 17.2598 2.9543 17.1655 2.91657C17.0712 2.87885 16.9701 2.86069 16.8686 2.86319C16.767 2.86569 16.667 2.8888 16.5746 2.93112C16.4823 2.97344 16.3995 3.03409 16.3312 3.10938L14.2125 5.22812C14.0722 5.36872 13.9935 5.55921 13.9935 5.75781C13.9935 5.95641 14.0722 6.1469 14.2125 6.2875C14.2823 6.35776 14.3657 6.4131 14.4576 6.45017C14.5494 6.48723 14.6478 6.50525 14.7469 6.50312ZM19.5 9.25H16.5C16.3011 9.25 16.1103 9.32902 15.9697 9.46967C15.829 9.61032 15.75 9.80109 15.75 10C15.75 10.1989 15.829 10.3897 15.9697 10.5303C16.1103 10.671 16.3011 10.75 16.5 10.75H19.5C19.6989 10.75 19.8897 10.671 20.0303 10.5303C20.171 10.3897 20.25 10.1989 20.25 10C20.25 9.80109 20.171 9.61032 20.0303 9.46967C19.8897 9.32902 19.6989 9.25 19.5 9.25ZM15.2719 13.7125C15.1292 13.5832 14.9423 13.5138 14.7498 13.5185C14.5574 13.5233 14.3741 13.6018 14.238 13.738C14.1018 13.8741 14.0233 14.0574 14.0185 14.2498C14.0138 14.4423 14.0832 14.6292 14.2125 14.7719L16.3312 16.8906C16.4009 16.9617 16.4841 17.0182 16.5758 17.0569C16.6676 17.0955 16.7661 17.1155 16.8656 17.1156C16.9638 17.1158 17.0611 17.0959 17.1513 17.0573C17.2416 17.0186 17.323 16.9619 17.3906 16.8906C17.4612 16.8216 17.5173 16.7393 17.5556 16.6483C17.5939 16.5573 17.6136 16.4596 17.6136 16.3609C17.6136 16.2622 17.5939 16.1645 17.5556 16.0736C17.5173 15.9826 17.4612 15.9002 17.3906 15.8312L15.2719 13.7125ZM10.5 15.25C10.3011 15.25 10.1103 15.329 9.96967 15.4697C9.82902 15.6103 9.75 15.8011 9.75 16V19C9.75 19.1989 9.82902 19.3897 9.96967 19.5303C10.1103 19.671 10.3011 19.75 10.5 19.75C10.6989 19.75 10.8897 19.671 11.0303 19.5303C11.171 19.3897 11.25 19.1989 11.25 19V16C11.25 15.8011 11.171 15.6103 11.0303 15.4697C10.8897 15.329 10.6989 15.25 10.5 15.25ZM5.72812 13.7125L3.60938 15.8312C3.53879 15.9002 3.4827 15.9826 3.44441 16.0736C3.40612 16.1645 3.38639 16.2622 3.38639 16.3609C3.38639 16.4596 3.40612 16.5573 3.44441 16.6483C3.4827 16.7393 3.53879 16.8216 3.60938 16.8906C3.67698 16.9619 3.7584 17.0186 3.84867 17.0573C3.93895 17.0959 4.03616 17.1158 4.13437 17.1156C4.23392 17.1155 4.33244 17.0955 4.42418 17.0569C4.51593 17.0182 4.59907 16.9617 4.66875 16.8906L6.7875 14.7719C6.91677 14.6292 6.98622 14.4423 6.98149 14.2498C6.97675 14.0574 6.89818 13.8741 6.76204 13.738C6.62591 13.6018 6.44264 13.5233 6.25017 13.5185C6.05771 13.5138 5.87079 13.5832 5.72812 13.7125ZM5.25 10C5.25 9.80109 5.17098 9.61032 5.03033 9.46967C4.88968 9.32902 4.69891 9.25 4.5 9.25H1.5C1.30109 9.25 1.11032 9.32902 0.96967 9.46967C0.829018 9.61032 0.75 9.80109 0.75 10C0.75 10.1989 0.829018 10.3897 0.96967 10.5303C1.11032 10.671 1.30109 10.75 1.5 10.75H4.5C4.69891 10.75 4.88968 10.671 5.03033 10.5303C5.17098 10.3897 5.25 10.1989 5.25 10ZM4.66875 3.10938C4.52608 2.98011 4.33917 2.91065 4.1467 2.91539C3.95424 2.92013 3.77097 2.9987 3.63483 3.13483C3.4987 3.27097 3.42013 3.45424 3.41539 3.6467C3.41065 3.83917 3.48011 4.02608 3.60938 4.16875L5.72812 6.2875C5.8699 6.42551 6.05995 6.50274 6.25781 6.50274C6.45567 6.50274 6.64572 6.42551 6.7875 6.2875C6.92776 6.1469 7.00653 5.95641 7.00653 5.75781C7.00653 5.55921 6.92776 5.36872 6.7875 5.22812L4.66875 3.10938Z" fill={color} />
  </svg>

);

export const RedirectionSpinner = ({
  width = 120,
  height = 120,
  size,
  style = {}
}: Exclude<IIcon, `color`>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    style={{
      "display": `block`,
      "animation": `spin 15s infinite linear`,
      ...style
    }}
    height={size || height}
    width={size || width}
    viewBox="0 0 100 100"
    preserveAspectRatio="xMidYMid"
  >
    <g transform="translate(50,50)">
      <circle
        cx="0"
        cy="0"
        r="8.333333333333334"
        fill="none"
        stroke="#97D6FC"
        strokeWidth="1.9000000000000001"
        strokeDasharray="13,08996939 39,2699081699"
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          values="0 0 0;1800 0 0"
          dur="3s"
          calcMode="spline"
          keySplines="0.76 0 0.36 0.99"
          begin="0"
          repeatCount="indefinite"
        />
      </circle>

      <circle
        cx="0"
        cy="0"
        r="16.666666666666668"
        fill="none"
        stroke="#97D6FCcc"
        strokeWidth="1.9000000000000001"
        strokeDasharray="26,1799387799 78,5398163397"
        transform="rotate(20, 0, 0)"
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          values="20 0 0;1460 0 0"
          dur="3s"
          calcMode="spline"
          keySplines="0.76 0 0.36 0.99"
          begin="0.1"
          repeatCount="indefinite"
        />
      </circle>

      <circle
        cx="0"
        cy="0"
        r="25"
        fill="none"
        stroke="#19A9FF"
        strokeWidth="1.9000000000000001"
        strokeDasharray="39,2699081699 117,8097245096"
        transform="rotate(40, 0, 0)"
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          values="40 0 0;1120 0 0"
          dur="3s"
          calcMode="spline"
          keySplines="0.76 0 0.36 0.99"
          begin="0.2"
          repeatCount="indefinite"
        />
      </circle>

      <circle
        cx="0"
        cy="0"
        r="33.333333333333336"
        fill="none"
        stroke="#19A9FFcc"
        strokeWidth="1.9000000000000001"
        strokeDasharray="52,3598775598 157,0796326795"
        transform="rotate(60, 0, 0)"
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          values="60 0 0;780 0 0"
          dur="3s"
          calcMode="spline"
          keySplines="0.76 0 0.36 0.99"
          begin="0.3"
          repeatCount="indefinite"
        />
      </circle>

      <circle
        cx="0"
        cy="0"
        r="41.666666666666664"
        fill="none"
        stroke="#19A9FF66"
        strokeWidth="1.9000000000000001"
        strokeDasharray="65,4498469498 196,3495408494"
        transform="rotate(80, 0, 0)"
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          values="80 0 0;440 0 0"
          dur="3s"
          calcMode="spline"
          keySplines="0.76 0 0.36 0.99"
          begin="0.4"
          repeatCount="indefinite"
        />
      </circle>
    </g>
  </svg>
);

export const CircleXmark = ({
  width = 24,
  height = 24,
  color = `currentColor`,
  style,
  size
}: IIcon) => (
  <svg
    height={size || height}
    width={size || width}
    style={style}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 24C18.6281 24 24 18.6281 24 12C24 5.37188 18.6281 0 12 0C5.37188 0 0 5.37188 0 12C0 18.6281 5.37188 24 12 24ZM8.20312 8.20312C8.64375 7.7625 9.35625 7.7625 9.79219 8.20312L11.9953 10.4062L14.1984 8.20312C14.6391 7.7625 15.3516 7.7625 15.7875 8.20312C16.2234 8.64375 16.2281 9.35625 15.7875 9.79219L13.5844 11.9953L15.7875 14.1984C16.2281 14.6391 16.2281 15.3516 15.7875 15.7875C15.3469 16.2234 14.6344 16.2281 14.1984 15.7875L11.9953 13.5844L9.79219 15.7875C9.35156 16.2281 8.63906 16.2281 8.20312 15.7875C7.76719 15.3469 7.7625 14.6344 8.20312 14.1984L10.4062 11.9953L8.20312 9.79219C7.7625 9.35156 7.7625 8.63906 8.20312 8.20312Z"
      fill={color}
    />
  </svg>
);
